<template>
  <div class="process-color d-flex justfiy-content-end">
    <div class="color-item d-flex align-items-center"
     v-for="(colorInfo,index) of colors" :key="`color-${index}`">
      <div class="square-item" :style="{backgroundColor: colorInfo.color}"></div>
      <div :style="{'color':skinType?'white':'#000'}">{{colorInfo.name}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'process-color',
  data() {
    return {
      colors: [
        {
          name: '开始节点',
          color: '#f0ad4e',
        }, {
          name: '需要处理',
          color: '#5bc0de',
        }, {
          name: '通过',
          color: '#5cb85c',
        }, {
          name: '未通过',
          color: '#d9534f',
        }, {
          name: '未处理',
          color: '#999999',
        },
      ],
    };
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
};
</script>
<style scoped>
.color-item+.color-item {
  margin-left:1rem;
}
.square-item{
  width:1rem;
  height:1rem;
  margin-right: 0.2rem;
}
.justfiy-content-end{
  justify-content: flex-end;
}
</style>
